import angular from 'angular';
import config from './dashboard.config';

import {Dashboard} from './dashboard.component';
import {DashboardHeader} from './dashboard-header/dashboard-header.component';
import {WaitingStudents} from './waiting-students/waiting-students.component';
import {HistoryAttendances} from './history-attendances/history-attendances.component';
import {AuthorizedOutsidePerson} from './authorized-outside-person/authorized-outside-person.component';
import {RegistrationWithCard, RegistrationWithCardController} from './registration-with-card/registration-with-card.component';
import {CardIdValidation, CardIdValidationCardController} from './registration-with-card/card-id-validation.component';
import {SelectStudentToRegister, SelectStudentToRegisterController} from './registration-with-card/select-student-to-register.component';
import {DeregistrationWithCard, DeregistrationWithCardController} from './deregistration-with-card/deregistration-with-card.component';
import {DeregisterCardIdValidation, DeregisterCardIdValidationCardController} from './deregistration-with-card/deregister-card-id-validation.component';
import {SelectStudentToDeregister, SelectStudentToDeregisterController} from './deregistration-with-card/select-student-to-deregister.component';
import RegisterStudentController from './register-student/register-student.controller';
import UnregisterStudentController from './unregister-student/unregister-student.controller';
import EditAttendanceController from './../attendances/edit-attendance/edit-attendance.controller';
import AddNewStudentController from './add-new-student/add-new-student.controller';
import StudentInfoController from './student-info/student-info.controller';

import './dashboard.scss';
import {MdtSelectionStore} from '../../util/mdt-selection.store';
import {mdtSelectionDecoratorConfig} from '../../util/mdt-selection.decorator';
/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.dashboard', [])
  .component('dashboardComponent', Dashboard)
  .component('dashboardHeader', DashboardHeader)
  .component('waitingStudents', WaitingStudents)
  .component('historyAttendances', HistoryAttendances)
  .component('authorizedOutsidePerson', AuthorizedOutsidePerson)
  .component('registrationWithCard', RegistrationWithCard)
  .component('cardidValidation', CardIdValidation)
  .component('selectStudentToRegister', SelectStudentToRegister)
  .component('deregistrationWithCard', DeregistrationWithCard)
  .component('deregisterCardIdValidation', DeregisterCardIdValidation)
  .component('selectStudentToDeregister', SelectStudentToDeregister)
  .controller('RegisterStudentController', RegisterStudentController)
  .controller('UnregisterStudentController', UnregisterStudentController)
  .controller('EditAttendanceController', EditAttendanceController)
  .controller('AddNewStudentController', AddNewStudentController)
  .controller('StudentInfoController', StudentInfoController)
  .controller('RegistrationWithCardController', RegistrationWithCardController)
  .controller('CardIdValidationCardController', CardIdValidationCardController)
  .controller('SelectStudentToRegisterController', SelectStudentToRegisterController)
  .controller('DeregistrationWithCardController', DeregistrationWithCardController)
  .controller('DeregisterCardIdValidationCardController', DeregisterCardIdValidationCardController)
  .controller('SelectStudentToDeregisterController', SelectStudentToDeregisterController)
  .service('MdtSelectionStore', MdtSelectionStore)
  .config(mdtSelectionDecoratorConfig)
  .config(config)
  .name;
